import React from 'react';
import BumpReport from './BumpReport';

const ShipmentBumpReport = () => {
    return (
        <div>
            <BumpReport from="shipment-bump-report" />
        </div>
    );
};

export default ShipmentBumpReport;
